import type { JSX } from 'react';
import { useColorPickerState } from './ColorPickerContext';
import type { ColorSwatchProps } from './ColorSwatch';
import { ColorSwatch } from './ColorSwatch';
import { DEFAULT_SWATCH_DIAMETER_PX } from './consts';

export type ValueSwatchProps = Pick<ColorSwatchProps, 'diameterPx'>;

/**
 * Renders a circular color swatch filled with the current color from
 * ColorPicker context. Accepts an optional `diameterPx` to control size.
 */
export const ValueSwatch = ({
  diameterPx = DEFAULT_SWATCH_DIAMETER_PX,
}: ValueSwatchProps): JSX.Element => {
  const { valueAsHex } = useColorPickerState();

  return (
    <ColorSwatch
      diameterPx={diameterPx}
      value={valueAsHex}
    />
  );
};

ValueSwatch.displayName = 'ValueSwatch';
